import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class ServiceButtonModel extends ButtonBase {
    label: string = 'Service';
    action: string = ACTION_STATUS.service;
    matIconName: string = 'restaurant_menu';
    colorClass: string = 'color-secondary-500';
}